<template>
  <div>
    <v-file-input color="#00ADB5" outlined dense :label="label" @change="handleFileUpload"></v-file-input>
    <v-progress-linear height="25px" rounded color="#00ADB5" background-color="#393E46" :value="uploadPercentage">
      <template v-slot:default="{ value }">
        <strong>{{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "FileUploader",

  props: ['uploadPercentage', 'label'],

  methods: {
    handleFileUpload(file) {
      this.$emit('fileUploaded', file)
    }
  }
}
</script>

<style scoped>

</style>
